import React, { useState, useEffect, useRef } from "react";
import "./App.css";
import Logo from "./triquetra-full-logo.svg";
import { SearchBar } from "./components/SearchBar";
import { SearchResultsList } from "./components/SearchResultsList";
import { Table } from "./components/table";
import SearchButton from "./components/SearchButton"; // Import the SearchButton component
import axios from "axios"; // Import axios
import { Map } from "./components/map"; // Import the Map component
import Switch from "@mui/material/Switch"; // Import Material-UI Switch component
import { green } from "@mui/material/colors";
import { styled } from "@mui/system";
import FormattedText from "./components/FormattedText";
import ColumnSelector from "./components/ColumnSelector";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faList,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import LoadingLogo from "./components/LoadingLogo";
import DropdownLists from "./components/DropdownLists";
import AboutModal from "./webGIScomponents/AboutModal";
import LoginPage from "./components/LoginPage";
import Funding from "./components/Funding";
import {
  TriggerButton,
  FiltersButton,
} from "./components/dss_components/TriggerButton";
import {
  faFilter,
  faPaperPlane,
  faRotateRight,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";

function App() {
  const [results, setResults] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [clickedKeywords, setClickedKeywords] = useState([]);
  const [isSwitchOn, setIsSwitchOn] = useState(true); // Define isSwitchOn state
  const [isMapSwitchOn, setIsMapSwitchOn] = useState(false); // Define isSwitchOn state
  const [selectedRow, setSelectedRow] = useState(null);
  const [loadingVisible, setLoadingVisible] = useState(true);
  const [input, setInput] = useState("");
  const [bounds, setBounds] = useState();
  const [value, setValue] = useState(null);
  const [initSearch, setInitSearch] = useState(false);
  const [activeRefresh, setActiveRefresh] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loginAUTH, setLoginAUTH] = useState(false);
  const [isCollumnSelectorVisible, setIsCollumnSelectorVisible] =
    useState(false);
  const logoImage = document.getElementById("logoImage");
  const host = process.env.REACT_APP_HOST;
  const isSmallScreen = window.innerWidth < 768;
  const defaultColumnOrder = [
    "title",
    "country",
    "pilotArea",
    "typeOfRisk",
    "monitoringMethod",
    "mitigationMeasure",
    "period",
    "siteContext",
    "typeOfMonument",
    "naturalEnvironment",
    "filename",
    "references",
    "url",
    //"id",
  ];

  const [selectedColumns, setSelectedColumns] = useState(defaultColumnOrder);
  // const [showFooter, setShowFooter] = useState(false);
  // const scrollContainerRef = useRef(null);

  //--------------------------------------UseEffect for authentication check----------------------------------------------------------//

  // useEffect(() => {
  //   const scrollContainer = scrollContainerRef.current;
  //   const handleScroll = () => {
  //     if (!scrollContainer) return;
  //     const scrollTop = scrollContainer.scrollTop;
  //     // Show footer after 100px scroll (adjust as needed)
  //     if (scrollTop > 100) {
  //       setShowFooter(true);
  //     } else {
  //       setShowFooter(false);
  //     }
  //   };

  //   window.addEventListener("scroll", handleScroll);

  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, []);

  useEffect(() => {
    axios
      .get(`${host}/checklogin`, { withCredentials: true })
      .then((response) => {
        console.log(response);
        const checkLogin = response.data;
        if (checkLogin === "loginTrue") {
          const loginContainer = document.getElementById("login-container");
          if (loginContainer) {
            loginContainer.style.display = "none";
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  //------------------------------------------------------------------------------------------------------------------------------------//

  const toggleModal = () => {
    //for toggling the about button modal
    setIsModalVisible(!isModalVisible);
  };

  const handleColumnSelect = (e) => {
    const column = e.target.value;

    setSelectedColumns((prevSelectedColumns) => {
      if (e.target.checked) {
        // If checked, add the column to the selected columns
        return [...prevSelectedColumns, column];
      } else {
        // If unchecked, remove the column from the selected columns
        return prevSelectedColumns.filter((col) => col !== column);
      }
    });
  };

  const columnOrder = [
    "title",
    "country",
    "pilotArea",
    "typeOfRisk",
    "monitoringMethod",
    "mitigationMeasure",
    "period",
    "siteContext",
    "typeOfMonument",
    "naturalEnvironment",
    "filename",
    "references",
    "url",
    //"id",
  ];

  // Function to update table data
  const updateTableData = (data) => {
    setTableData(data);
  };

  const refreshSearch = () => {
    setClickedKeywords([]);
  };

  const RefreshButton = ({ active, refreshSearch }) => {
    function handleOnClick() {
      refreshSearch();
    }
    return (
      <div
        className={"dss-refresh-btn-bibliography " + (active ? "active" : "")}
        onClick={() => handleOnClick()}
      >
        <FontAwesomeIcon icon={faRotateRight} />
      </div>
    );
  };

  const onRowClick = (row) => {
    setSelectedRow(row);
  };

  const clearInput = () => {
    setInput("");
  };

  const handleSearchButtonClick = () => {
    setResults([]);
    setValue(null);

    setSelectedRow(null);
    // Send a POST request with all clicked keywords and isSwitchOn value
    axios
      .post(`${host}/paper`, {
        keywords: clickedKeywords,
        or: isSwitchOn,
      })
      .then((response) => {
        // Update the table data
        updateTableData(response.data);

        setBounds(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });

    // Log the saved keywords and switch value to the console
    console.log("Saved Keywords:", clickedKeywords);
    console.log("Switch Value:", isSwitchOn);
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearchButtonClick();
    }
  };
  document.addEventListener("keydown", handleKeyPress);

  const GreenSwitch = styled(Switch)(({ theme }) => ({
    "& .MuiSwitch-switchBase.Mui-checked": {
      color: green[900],
    },
    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
      backgroundColor: green[600],
    },
  }));

  const [isColumnSelectorVisible, setColumnSelectorVisible] = useState(false);

  // const resetData = () =>{
  //   setTableData([]);
  //   setSelectedRow(null);
  //   setClickedKeywords([]);

  // }

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoadingVisible(false);
    }, 2300);

    return () => clearTimeout(timer);
  }, []);
  // useEffect(() =>{
  //   return () => setSelectedRow(!responseFromMap)
  // }, [responseFromMap]
  // )
  const changeFooterContainerStyle = () => {};

  const handleCollumnSelector = () => {
    setIsCollumnSelectorVisible(!isCollumnSelectorVisible);
  };

  return (
    <div className="App">
      {!loginAUTH && <LoginPage setLoginAUTH={setLoginAUTH} />}

      {isModalVisible && <AboutModal toggleModal={toggleModal} />}
      <main className="main">
        <div className="header">
          <a href="./">
            <img
              src={Logo}
              alt="Company Logo"
              className="logo"
              id="logoImage"
            />
          </a>
          <div className="manual-about-wrapper">
            <a
              className="manual-button"
              href="/TRIQUETRA-KBP-user-manual.pdf"
              // download="TRIQUETRA-KBP-user-manual.pdf"
              target="_blank"
            >
              Manual
            </a>
            <button className="about-button" onClick={toggleModal}>
              {" "}
              About
            </button>
          </div>
        </div>

        {loadingVisible && <LoadingLogo />}

        <div className="search-bar-container">
          <SearchBar
            setResults={setResults}
            updateTableData={updateTableData}
            clickedKeywords={clickedKeywords}
            setClickedKeywords={setClickedKeywords}
            setInput={setInput}
            setValue={setValue}
          />
          <SearchResultsList
            results={results}
            onResultClick={(result) =>
              setClickedKeywords([...clickedKeywords, result])
            }
            clearInput={clearInput}
          />
          <SearchButton onClick={handleSearchButtonClick} />

          <DropdownLists
            setClickedKeywords={setClickedKeywords}
            clickedKeywords={clickedKeywords}
            setIsSwitchOn={setIsSwitchOn}
          />

          {/* Material-UI Switch component */}
          <div className="mui-switch-container">
            <span className="switch-label">And</span>
            <label className="switch">
              <GreenSwitch
                checked={isSwitchOn}
                onChange={() => setIsSwitchOn(!isSwitchOn)}
                inputProps={{ "aria-label": "Switch demo" }}
              />
            </label>
            <span className="switch-label">Or</span>
          </div>
        </div>
        {<RefreshButton active={activeRefresh} refreshSearch={refreshSearch} />}
        {!(tableData.length === 0) && (
          <div className="table-container">
            <div className="list-button" onClick={handleCollumnSelector}>
              {isCollumnSelectorVisible ? (
                <span>
                  <FontAwesomeIcon icon={faChevronLeft} /> Filters
                </span>
              ) : (
                <span>
                  Filters <FontAwesomeIcon icon={faChevronRight} />
                </span>
              )}
            </div>
            <div
              className={`columnSelector ${
                isCollumnSelectorVisible ? "visible" : "hidden"
              }`}
            >
              <ColumnSelector
                columnOrder={defaultColumnOrder}
                selectedColumns={selectedColumns}
                onColumnSelect={handleColumnSelect}
              />
            </div>

            <div className="search-table">
              <Table
                tableData={tableData}
                onRowClick={onRowClick}
                selectedColumns={selectedColumns}
              />
            </div>
          </div>
        )}
        {/* <div
          className={`footer-container ${showFooter ? "visible" : "hidden"}`}
          div
        > */}
        <div
          className="footer-container"
          style={{ gridRow: tableData.length === 0 ? "3 / span 2" : "4" }}
        >
          {selectedRow && (
            <div className="selected-row">
              <div>
                <button
                  className="close-button"
                  onClick={() => setSelectedRow(null)}
                >
                  ✕
                </button>

                <FormattedText selectedRow={selectedRow} />
              </div>
            </div>
          )}
          <div className="map-container">
            <div
              className="mui-mapSwitch-container"
              style={{
                left: selectedRow ? "36.7%" : "10px",
                top:
                  tableData.length === 0
                    ? "2%"
                    : isSmallScreen
                    ? "2%" // for small screens
                    : "2%",
              }}
            >
              <span className="switch-label2"></span>
              <label className="mapSwitch">
                <GreenSwitch
                  checked={isMapSwitchOn}
                  onChange={() => setIsMapSwitchOn(!isMapSwitchOn)}
                  inputProps={{ "aria-label": "Switch demo" }}
                />
              </label>
              <span className="mapSwitch-label">Map Search</span>
            </div>
            <Map
              tableData={tableData}
              updateTableData={updateTableData}
              isMapSwitchOn={isMapSwitchOn}
              onRowClick={onRowClick}
              setSelectedRow={setSelectedRow}
              clickedKeywords={clickedKeywords}
              selectedRow={selectedRow}
              bounds={bounds}
            />
          </div>
        </div>
      </main>

      <Funding />
    </div>
  );
}

export default App;
